// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationWebpageFinalApi,
  ICertificationWebpageFinalApiRequest,
  ICertificationWebpageFinalApiFinishAttrs,
  ICertificationWebpageFinalApiFinishResponse,
} from 'interfaces/webpage/certification/registration/final/final-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class CertificationWebpageFinalApi
  extends BaseApi<ICertificationWebpageFinalApi>
  implements ICertificationWebpageFinalApiRequest
{
  readonly url = ApiConstantHc.CERTIFICATION_REGISTRATION_FINAL
  private certificationRegistrationFinalUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Finish registration of certificate
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpageFinalApiFinishAttrs} payload
   *
   * @return {Promise<ICertificationWebpageFinalApiFinishResponse>} Promise<ICertificationWebpageFinalApiFinishResponse>
   */
  async certificationWebpageFinal_finish(
    payload: ICertificationWebpageFinalApiFinishAttrs,
  ): Promise<ICertificationWebpageFinalApiFinishResponse> {
    return this.POST(
      `${this.certificationRegistrationFinalUrl}/finish/${payload.params.assessmentId}`,
      {},
      { ...payload.requestConfig },
    )
  }
}
